import {
  createView,
  createViewBuilder,
  generateBindings,
  View,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-list/mwc-list-item.js';
import { GraphicType } from '@material/mwc-list/mwc-list-item.js';
import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

export class ListItemView extends View {
  value = '';
  twoline = false;
  graphic: GraphicType = null;
  content: (View | string)[] = [];

  get body() {
    const bindings = generateBindings(this, ['content']);
    const enventsBindings = generateBindings(this.events);

    return html`
      <mwc-list-item
        ${spread({ ...this.attrs, ...bindings, ...enventsBindings })}
        .view="${this}"
        style="${styleMap(this.styles)}"
      >
        ${this.content.map(el => (typeof el === 'string' ? el : el.body))}
      </mwc-list-item>
    `;
  }
}

export function ItemGraphic(graphic: View) {
  return graphic.slot('graphic');
}

export function ItemSecondaryLine(sec: View | string) {
  return typeof sec === 'string'
    ? createView(html`<span slot="secondary">${sec}</span>`)
    : sec.slot('secondary');
}

export function ListItem(...content: (View | string)[]) {
  return createViewBuilder(ListItemView).content(content);
}
ListItem.View = ListItemView;
